/* eslint-disable max-params */

export const displayUpsellNames = (upsells) => {
  const getUpsellsNames = upsells?.map((upsell) => upsell?.productInfo?.label);

  const upsellAttendees = upsells?.map((upsell, index) =>
    upsell?.pricingInfo?.attendees?.filter((el) => el?.rentedAmount?.value > 0).length > 0
      ? `${upsell?.pricingInfo?.attendees?.filter((el) => el?.rentedAmount?.value > 0).length} ${
          getUpsellsNames[index]
        }`
      : null,
  );

  return upsellAttendees.filter((upsell) => upsell)?.join(' | ');
};

export const displayActivitiesAndEquipmentsNames = (
  hasActivities,
  hasEquipments,
  activities,
  equipments,
) => {
  if (hasActivities && !hasEquipments) {
    return displayUpsellNames(activities);
  }
  if (!hasActivities && hasEquipments) {
    return displayUpsellNames(equipments);
  }
  if (hasEquipments) {
    return `${displayUpsellNames(activities)} | ${displayUpsellNames(equipments)}`;
  }
};
